
import {Vue, Component, Emit, Prop, Watch} from 'vue-property-decorator';
import moment, {Moment} from 'moment';
import Empty from '@/components/Empty/index.vue';
import {isSectionTimeDisabled, isSectionTimeNoBegin, WeekTexts} from './utils';
export const CardStatus = {
    active: 'active',
    normal: 'normal',
    disabled: 'disabled'
};

export interface DateType {
    startDate: string;
    endDate: string;
    dateString: string;
    week: number;
}
export interface ScheduleDataItemType {
    name: string;
    title?: string;
    className: string;
    teacherName: string;
    classId: string;
    classIndex: number;
    disabled?: boolean;
    id: string;
    remark?: string;
    scheduledClassContent?: {
        courseId: string;
        courseName?: string;
        cascadedNodes: {
            id: string;
            name: string;
            nodeType: number;
        }[];
    };
    scheduledDate: string;
    teacherId: string;
}

export type ScheduleDatasType = (ScheduleDataItemType[] | null)[][];

@Component({
    components: {
        Empty
    }
})
export default class ScheduleComponent extends Vue {
    @Prop({default: true}) showTeacherName?: boolean;
    @Prop({default: true}) allowOperation?: boolean;
    @Prop({default: []}) sections?: {
        text: string;
        startTime: string;
        endTime: string;
    }[];
    // [[[周一第一节1, 周一第一节2],[周一第二节1],null],[[周二第一节1, 周二第一节2],[周二第二节1]]] 周一到周日数组；周一第一节到第七节数组；第一节多课程数组
    @Prop({default: []}) datas!: ScheduleDatasType;
    //===================================data区域begin
    emptySection = [
        {
            text: '',
            startTime: '',
            endTime: ''
        }
    ];
    weekDate = moment();
    dates: string[] = [];
    date: DateType = {
        startDate: '',
        endDate: '',
        dateString: '',
        week: 0
    };
    weekTexts = WeekTexts;

    BackgroundColors = ['#447BF4', '#23C8BD', '#23CD9D', '#F3B91B', '#EE7241', '#DC5289', '#CA66C9', '#798FA7', '#DE3733'];
    CardStatus = CardStatus;
    refreshKey = Date.now();

    @Watch('date')
    watchExpanded(nv: DateType, ov: DateType) {
        if (nv?.dateString && nv?.dateString !== ov?.dateString) this.$emit('changeDate', nv);
    }

    //===================================data区域end

    //===================================computed区域begin
    get weekDates() {
        const {startDate} = this.date;
        const result = [];
        for (let i = 0; i < 7; i++) {
            result.push(moment(startDate, 'YYYY/MM/DD').add(i, 'days').format('MM/DD'));
        }
        return result;
    }
    get dateText() {
        const {startDate, endDate, week} = this.date;
        return `${startDate}-${endDate} 第${week}周`;
    }

    get todayWeekday() {
        const {startDate, endDate} = this.date;
        const hasToday = moment().isBetween(moment(startDate, 'YYYY/MM/DD'), moment(endDate, 'YYYY/MM/DD'));
        if (hasToday) {
            return moment().weekday();
        }
        return false;
    }

    get dateStatus() {
        const {startDate, endDate} = this.date;
        const hasToday = moment().isBetween(moment(startDate, 'YYYY/MM/DD'), moment(endDate, 'YYYY/MM/DD'));

        if (hasToday) {
            return {
                type: 'hasToday',
                weekday: moment().weekday()
            };
        }
        return {
            type: moment(endDate, 'YYYY/MM/DD').isBefore(moment()) ? 'before' : 'after'
        };
    }

    get formatDatas() {
        const BackgroundColors = this.BackgroundColors;
        const len = BackgroundColors.length;
        let teacherArr: string[] = [];
        if (!(this.datas && this.datas.length)) {
            return [];
        }
        const result = this.datas.map((data: any, dayIndex: number) => {
            let status = this.getDateStatusWithWeekday(dayIndex);
            // 今天

            return data.map((item: any, sectionIndex: number) => {
                if (item && item.length) {
                    return item.map((_item: any) => {
                        const {teacherId, scheduledDate, classIndex} = _item;
                        let teacherIndex = teacherArr.indexOf(teacherId);
                        if (teacherIndex < 0) {
                            teacherIndex = teacherArr.push(teacherId) - 1;
                        }
                        const _status = this.getTodayCourseStatus(status, classIndex);

                        const disabled = !(this.hasSectionLen && classIndex >= 0 && classIndex < this.hasSectionLen);
                        let dateText = '';
                        if (!disabled && this.sections) {
                            const {startTime, endTime, text} = this.sections[classIndex];
                            dateText = `${text} ${startTime}-${endTime}`;
                        }
                        const date = `${scheduledDate.replace(/-/g, '/')} ${dateText}`;
                        return {
                            ..._item,
                            backgroundColor: this.BackgroundColors[teacherIndex % len],
                            status: _status,
                            _key: this.refreshKey,
                            date
                        };
                    });
                }
                return null;
            });
        });
        return result;
    }

    get hasSectionLen() {
        return this.sections && this.sections.length;
    }

    get renderSections() {
        const hasDisabled = this.datas.some((data: any) => {
            return (data || []).some((item: any) => {
                if (item && item.length) {
                    return item.some((_item: any) => _item.disabled);
                }
                return false;
            });
        });
        if (hasDisabled) {
            return (this.sections || []).concat(this.emptySection);
        }
        return this.sections || [];
    }

    //===================================computed区域end

    //===================================methods区域begin
    hidePopover(className: string) {
        const $target = this.$el.querySelector(`${className} .ant-popover`);
        if ($target) {
            const style = $target.getAttribute('style') + 'display:none';
            $target.setAttribute('style', style);
        }
    }
    deleteItem(cardItem: ScheduleDataItemType, className: string) {
        this.$emit('onDelete', cardItem);
        this.hidePopover(className);
    }
    editItem(cardItem: ScheduleDataItemType, className: string) {
        this.$emit('onEdit', cardItem);
        this.hidePopover(className);
    }
    refreshData() {
        this.refreshKey = Date.now();
    }
    openSettingDialog() {
        this.$emit('openSettingDialog');
    }
    getAddStatus(weekIndex: number, classIndex: number) {
        let status = this.getDateStatusWithWeekday(weekIndex);
        const disabled = !(this.hasSectionLen && classIndex >= 0 && classIndex < this.hasSectionLen);

        if (disabled) {
            status = CardStatus.disabled;
        }
        if (status === CardStatus.active && this.sections) {
            const {endTime} = this.sections[classIndex];
            if (isSectionTimeDisabled(endTime)) {
                status = CardStatus.disabled;
            } else {
                status = CardStatus.normal;
            }
        }

        return status === CardStatus.normal;
    }
    getTodayCourseStatus(status: string, classIndex: number) {
        const disabled = !(this.hasSectionLen && classIndex >= 0 && classIndex < this.hasSectionLen);
        if (disabled) {
            return CardStatus.disabled;
        }
        if (status === CardStatus.active && this.sections) {
            const {endTime, startTime} = this.sections[classIndex];
            if (isSectionTimeDisabled(endTime)) {
                return CardStatus.disabled;
            }
            if (isSectionTimeNoBegin(startTime)) {
                return CardStatus.normal;
            }
        }
        return status;
    }
    getDateStatusWithWeekday(weekIndex: number) {
        const dateStatus = this.dateStatus;
        const status =
            dateStatus.type === 'before'
                ? CardStatus.disabled
                : dateStatus.type === 'hasToday' && dateStatus.weekday === weekIndex
                ? CardStatus.active
                : dateStatus.type === 'hasToday' && dateStatus.weekday && dateStatus.weekday > weekIndex
                ? CardStatus.disabled
                : CardStatus.normal;
        return status;
    }
    onChange(date: Moment, dateString: string) {
        if (!date) return;
        this.weekDate = date;
        const weekday = date.weekday();
        const week = date.week();
        const startDate = date.subtract(weekday, 'days').format('YYYY/MM/DD');
        const endDate = date.add(6, 'days').format('YYYY/MM/DD');
        this.date = {
            startDate,
            endDate,
            dateString,
            week
        };
        this.getList();
    }
    getList() {}
    setToday() {
        const dateString = moment().year() + '-' + moment().week();
        this.onChange(moment(), dateString);
    }
    changeWithWeek(week: number) {
        const targetMoment = moment().week(week);
        const dateString = `${targetMoment.year()}-${week}`;
        this.onChange(targetMoment, dateString);
    }
    prevWeek() {
        this.changeWithWeek(this.date.week - 1);
    }
    nextWeek() {
        this.changeWithWeek(this.date.week + 1);
    }

    addSchedule(weekIndex: number, sectionIndex: number) {
        const date = moment(this.date.startDate, 'YYYY/MM/DD').day(weekIndex + 1);
        this.$emit('onCreate', {
            date,
            sectionIndex,
            weekIndex
        });
    }
    /**
     * 获取本周周一和周日日期
     */
    // getCurrentWeek() {
    //     const startDate = moment()
    //         .weekday(1)
    //         .format('YYYY-MM-DD'); //本周一
    //     const endDate = moment()
    //         .weekday(7)
    //         .format('YYYY-MM-DD'); //本周日
    //     const dateString = moment().year() + '-' + moment().week();
    //     return [startDate, endDate, dateString];
    // }

    //===================================methods区域end

    created() {
        this.setToday();
    }
}
